import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useThemeColor } from '../Theme';
import { useTranslate } from '../util';
import { CheckmarkInCircleSolidIcon, ExclamationInDiamondSolidIcon, ExclamationInTriangleSolidIcon, IInCircleSolidIcon } from './baseIcons';
export function AlertErrorIcon(props) {
  var t = useTranslate();
  return /*#__PURE__*/React.createElement(ExclamationInDiamondSolidIcon, _extends({}, props, {
    alt: t('citrix-ui:svg.AlertIcon'),
    color: useThemeColor('errorBorder')
  }));
}
export function AlertInfoIcon(props) {
  var t = useTranslate();
  return /*#__PURE__*/React.createElement(IInCircleSolidIcon, _extends({}, props, {
    alt: t('citrix-ui:svg.InfoIcon'),
    color: useThemeColor('infoBorder')
  }));
}
export function AlertSuccessIcon(props) {
  var t = useTranslate();
  return /*#__PURE__*/React.createElement(CheckmarkInCircleSolidIcon, _extends({}, props, {
    alt: t('citrix-ui:svg.SuccessIcon'),
    color: useThemeColor('successBorder')
  }));
}
export function AlertWarningIcon(props) {
  var t = useTranslate();
  return /*#__PURE__*/React.createElement(ExclamationInTriangleSolidIcon, _extends({}, props, {
    alt: t('citrix-ui:svg.WarningIcon'),
    color: useThemeColor('warningBorder')
  }));
}